export default __webpack_public_path__ + "static/media/Screenshot13.5109c8f0.png";